import React, { Component } from "react";
import { Form } from 'react-bootstrap';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import SyncIcon from '@material-ui/icons/Sync';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


//Services
import { OrganisationService } from "../Services/OrganisationService";
import { FormControlLabel, Switch } from "@material-ui/core";


const styles = theme => ({
    root: {
        flexGrow: 1,
        textAlign: 'justify',
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "95%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom: '20px'
    },
    leftIcon: {
        marginRight: theme.spacing(1),
    },
    button: {
        margin: theme.spacing(1),
    },
    dividerFullWidth: {
        margin: `5px 0 0 ${theme.spacing(2)}px`,
    },
    dividerInset: {
        margin: `5px 0 0 ${theme.spacing(1)}px`,
    },
});

class OrganisationInformation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modal: { id: '', name: '', gst_no: '', pan_no: '', address: '', phone: '', email: '', bank_details: '', invoice_prefix: '', invoice_no: '', credit_note_no: '' },
            organisation: {},
            show: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.updateDetails = this.updateDetails.bind(this);
        this.enableDueCheck = this.enableDueCheck.bind(this)
    }

    componentDidMount() {
        this.props.setTitle('Organisation Information');
        this.fetchData();
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            modal: { id: '', name: '', gst_no: '', pan_no: '', address: '', phone: '', email: '', bank_details: '', invoice_prefix: '', invoice_no: '', credit_note_no: '' }
        });
    }

    handleShow() {
        let org = this.state.organisation;
        this.setState({ show: true, modal: { id: org.id, name: org.name, gst_no: org.gst_no, pan_no: org.pan_no, address: org.address, phone: org.phone, email: org.email, bank_details: org.bank_details, invoice_prefix: org.invoice_prefix, invoice_no: org.invoice_no, credit_note_no: org.credit_note_no } });
    }

    handleChange(e) {
        e.preventDefault();
        let change = this.state.modal;
        change[e.target.name] = e.target.value;
        this.setState({ modal: change });
    }

    fetchData() {
        this.props.isLoading(true);
        OrganisationService.getOrganisationDetails()
            .then((data) => {
                console.log(data);
                this.setState({ organisation: data.organisation ? data.organisation : {} });
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
    }

    updateDetails(e) {
        e.preventDefault();
        OrganisationService.updateOrganisationInformation(this.state.modal)
            .then((data) => {
                console.log(data);
                this.props.isLoading(false);
                this.handleClose();
                this.fetchData();
                this.props.showSnackBar('Updated organisation information', 'success');
            })
            .catch(() => {
                this.props.showSnackBar(`Something went wrong. Please try again later.`, 'error');
                this.props.isLoading(false);
            });

    }

    resetDialog = () => {
        this.props.showConfirmDialog("Confirm reset of Invoice number?", undefined, () => {
            this.resetInvoiceNo();
            this.props.closeConfirmDialog();
        });
    }

    resetCreditNoteDialog = () => {
        this.props.showConfirmDialog("Confirm reset of Credit Note number?", undefined, () => {
            this.resetCreditNoteNo();
            this.props.closeConfirmDialog();
        });
    }

    resetPaymentReceiptDialog = () => {
        this.props.showConfirmDialog("Confirm reset of Payment Receipt number?", undefined, () => {
            this.resetPaymentReceiptNo();
            this.props.closeConfirmDialog();
        });
    }

    resetInvoiceNo = () => {
        OrganisationService.resetInvoiceNo({})
            .then((result) => {
                if (result) {
                    this.setState(prevState => {
                        return {
                            organisation: {
                                ...prevState.organisation,
                                invoice_no: 1
                            }
                        }
                    });
                    this.props.showSnackBar('Resetted Invoice No', 'success');
                } else {
                    this.props.showSnackBar('Something went wrong. Please try again later.', 'error');
                }
            });
    }

    resetPaymentReceiptNo = () => {
        OrganisationService.resetPaymentNo({})
            .then((result) => {
                if (result) {
                    this.setState(prevState => {
                        return {
                            organisation: {
                                ...prevState.organisation,
                                payment_no: 1
                            }
                        }
                    });
                    this.props.showSnackBar('Resetted Payment Receipt No', 'success');
                } else {
                    this.props.showSnackBar('Something went wrong. Please try again later.', 'error');
                }
            });
    }

    resetCreditNoteNo = () => {
        OrganisationService.resetCreditNoteNo({})
            .then((result) => {
                if (result) {
                    this.setState(prevState => {
                        return {
                            organisation: {
                                ...prevState.organisation,
                                credit_note_no: 1
                            }
                        }
                    });
                    this.props.showSnackBar('Resetted Credit Note No', 'success');
                } else {
                    this.props.showSnackBar('Something went wrong. Please try again later.', 'error');
                }
            });
    }

    enableAutoScheduling = (organisation, name) => event => {
        let value = event.target.checked;
        this.props.showConfirmDialog("Are you sure you want to change the configuration", "Warning", () => {
            this.confirm(organisation, value);
        });
    }

    enableDueCheck = (organisation, name) => event => {
        let value = event.target.checked;
        this.props.showConfirmDialog("Are you sure you want to change the configuration", "Warning", () => {
            let body = { scheduling_due_check: value };
            this.setState(prevState => {
                return {
                    organisation: {
                        ...prevState.organisation,
                        scheduling_due_check: value ? "1" : "0"
                    }
                }
            });
            let headers = { "user-id": this.props.user.id, 'user-name': this.props.user.name };

            OrganisationService.enableDueCheck(headers, body)
                .then((response) => {
                    console.log(response);
                    this.props.showSnackBar(`${value ? "Enabled" : "Disabled"} due check for ${organisation.name}`, 'success');
                    this.props.isLoading(false);
                })
                .catch(() => {
                    this.props.isLoading(false);
                    this.props.showConfirmDialog(`Failed to update organisation : ${organisation.name}. Please try again.`, undefined, undefined);
                });
            this.props.closeConfirmDialog();
        });
    }

    confirm = (organisation, value) => {

        let body = { auto_schedule_enabled: value };
        this.setState(prevState => {
            return {
                organisation: {
                    ...prevState.organisation,
                    auto_schedule_enabled: value ? "1" : "0"
                }
            }
        });
        let headers = { "user-id": this.props.user.id, 'user-name': this.props.user.name };

        OrganisationService.enableAutoScheduling(headers, body)
            .then((response) => {
                console.log(response);
                this.props.showSnackBar(`${value ? "Enabled" : "Disabled"} auto scheduling for ${organisation.name}`, 'success');
                this.props.isLoading(false);
            })
            .catch(() => {
                this.props.isLoading(false);
                this.props.showConfirmDialog(`Failed to update organisation : ${organisation.name}. Please try again.`, undefined, undefined);
            });
        this.props.closeConfirmDialog();
    }

    render() {
        let org = this.state.organisation;
        let classes = this.props.classes;
        return (!this.props.loading &&
            <div className={classes.root} style={{ marginTop: 24 }}>
                <br />
                <Paper className={classes.paper}>

                    <div style={{ float: "right" }}>
                        <Button variant="contained" size="small" color="primary" className={classes.button} onClick={this.handleShow}>
                            Edit
                            {/* <Glyphicon style={{marginRight: "10px",}} glyph="pencil" title="Edit"/>Edit */}
                            <EditIcon className={classes.leftIcon} />
                        </Button>
                        <Button variant="contained" size="small" color="secondary" className={classes.button} onClick={this.resetDialog}>
                            Reset Invoice No
                            {/* <Glyphicon style={{marginRight: "10px",}} glyph="pencil" title="Edit"/>Edit */}
                            <SyncIcon className={classes.leftIcon} />
                        </Button>
                        <Button variant="contained" size="small" color="secondary" className={classes.button} onClick={this.resetCreditNoteDialog}>
                            Reset Credit Note No
                            {/* <Glyphicon style={{marginRight: "10px",}} glyph="pencil" title="Edit"/>Edit */}
                            <SyncIcon className={classes.leftIcon} />
                        </Button>
                        <Button variant="contained" size="small" color="secondary" className={classes.button} onClick={this.resetPaymentReceiptDialog}>
                            Reset Payment Receipt No
                            {/* <Glyphicon style={{marginRight: "10px",}} glyph="pencil" title="Edit"/>Edit */}
                            <SyncIcon className={classes.leftIcon} />
                        </Button>
                    </div>
                    <br />
                    <br />
                    <Grid container className={classes.root} spacing={1}>
                        <Grid item xs={12}>
                            <Typography variant="h5" component="h2">
                                Organisation
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        Name
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left' }}>
                                        {org.name}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        GST No
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left' }}>
                                        {org.gst_no}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        PAN No
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left' }}>
                                        {org.pan_no}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider variant="inset" />
                        </Grid>
                        {/* Contact Info */}
                        <Grid item xs={12}>
                            <Typography variant="h5" component="h2">
                                Contact information
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        Address
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <span style={{ float: 'left', textAlign: 'justify' }}>
                                        {org.address && org.address.split('\n').map((i, index) => {
                                            return <span key={index}>
                                                {i}
                                                <br />
                                            </span>
                                        })}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        Contact No
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left' }}>
                                        {org.phone}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        Email
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left' }}>
                                        {org.email}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider variant="inset" />
                        </Grid>
                        {/* Bank Info */}
                        <Grid item xs={12}>
                            <Typography variant="h5" component="h2">
                                Bank Details
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        Bank Details
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left', textAlign: 'justify' }}>
                                        {org.bank_details && org.bank_details.split('\n').map((i, index) => {
                                            return <span key={index}>
                                                {i}
                                                <br />
                                            </span>
                                        })}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider variant="inset" />
                        </Grid>
                        {/* Invoice Details */}
                        <Grid item xs={12}>
                            <Typography variant="h5" component="h2">
                                Invoicing Details
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        Invoice Prefix
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left', textAlign: 'justify' }}>
                                        {org.invoice_prefix}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        Current Invoice No
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left', textAlign: 'justify' }}>
                                        {org.invoice_no}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        Current Credit Note No
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left', textAlign: 'justify' }}>
                                        {org.credit_note_no ? org.credit_note_no : 1}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        Current Payment Receipt No
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left', textAlign: 'justify' }}>
                                        {org.payment_no ? org.payment_no : 1}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider variant="inset" />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        Auto Scheduling
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left', textAlign: 'justify' }}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={org.auto_schedule_enabled === "1" ? true : false}
                                                    value="auto_schedule_enabled"
                                                    color="primary"
                                                    onChange={this.enableAutoScheduling(org, 'auto_schedule_enabled')}
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                />
                                            }
                                            label={org.auto_schedule_enabled === "1" ? "Enabled" : "Disabled"} />
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="subtitle1">
                                        Credit limit/due limit check while placing order
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <span style={{ float: 'left', textAlign: 'justify' }}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={org.scheduling_due_check === "1" ? true : false}
                                                    value="scheduling_due_check"
                                                    color="primary"
                                                    onChange={this.enableDueCheck(org, 'scheduling_due_check')}
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                />
                                            }
                                            label={org.scheduling_due_check === "1" ? "Enabled" : "Disabled"} />
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
                <DialogMUI
                    disableBackdropClick
                    open={this.state.show}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    <DialogTitle id="alert-dialog-title">Organisation Details</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" component={'span'}>
                            <Form horizontal onSubmit={this.updateDetails}>
                                <TextField
                                    id="name"
                                    label="Name"
                                    placeholder="Name"
                                    name="name"
                                    defaultValue={this.state.modal.name}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    fullWidth />
                                <TextField
                                    id="gst_no"
                                    label="GST No"
                                    placeholder="GST No"
                                    name="gst_no"
                                    defaultValue={this.state.modal.gst_no}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    fullWidth />
                                <TextField
                                    id="pan_no"
                                    label="PAN No"
                                    placeholder="PAN No"
                                    name="pan_no"
                                    defaultValue={this.state.modal.pan_no}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    fullWidth />
                                <TextField
                                    id="address"
                                    label="Address"
                                    placeholder="Address"
                                    name="address"
                                    defaultValue={this.state.modal.address}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    fullWidth
                                    multiline
                                    rowsMax="4" />
                                <TextField
                                    id="phone"
                                    label="Contact No"
                                    placeholder="Contact No"
                                    name="phone"
                                    defaultValue={this.state.modal.phone}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    fullWidth />
                                <TextField
                                    id="email"
                                    label="Email"
                                    placeholder="Email"
                                    name="email"
                                    defaultValue={this.state.modal.email}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    fullWidth />
                                <TextField
                                    id="bank_details"
                                    label="Bank Details"
                                    placeholder="Bank Details"
                                    name="bank_details"
                                    defaultValue={this.state.modal.bank_details}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    fullWidth
                                    multiline
                                    rowsMax="4" />
                                <TextField
                                    id="invoice_prefix"
                                    label="Invoice Prefix"
                                    placeholder="Invoice Prefix"
                                    name="invoice_prefix"
                                    defaultValue={this.state.modal.invoice_prefix}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    fullWidth />
                                <TextField
                                    id="invoice_no"
                                    label="Invoice number"
                                    placeholder="Invoice number"
                                    name="invoice_no"
                                    defaultValue={this.state.modal.invoice_no}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    pattern="[0-9]*"
                                    type="number"
                                    InputProps={{
                                        inputProps: { min: 1 }
                                    }}
                                    required
                                    fullWidth />
                                <TextField
                                    id="credit_note_no"
                                    label="Credit Note number"
                                    placeholder="Credit Note number"
                                    name="credit_note_no"
                                    defaultValue={this.state.modal.credit_note_no}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    pattern="[0-9]*"
                                    type="number"
                                    InputProps={{
                                        inputProps: { min: 1 }
                                    }}
                                    required
                                    fullWidth />
                                <TextField
                                    id="payment_no"
                                    label="Payment Receipt number"
                                    placeholder="Payment Receipt number"
                                    name="payment_no"
                                    defaultValue={this.state.modal.payment_no}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    pattern="[0-9]*"
                                    type="number"
                                    InputProps={{
                                        inputProps: { min: 1 }
                                    }}
                                    required
                                    fullWidth />
                            </Form>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.updateDetails} color="primary" autoFocus>
                            Confirm
                        </Button>
                    </DialogActions>
                </DialogMUI>
            </div>
        );
    }
}

export default withStyles(styles)(OrganisationInformation);